import React, { useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight, Star } from 'lucide-react';
import { testimonials } from '../mockData';
import { Button } from './ui/button';
import { Card } from './ui/card';

export const TestimonialsSlider = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);

  useEffect(() => {
    if (!isAutoPlaying) {
      const resumeTimer = setTimeout(() => setIsAutoPlaying(true), 10000);
      return () => clearTimeout(resumeTimer);
    }

    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % testimonials.length);
    }, 4000);

    return () => clearInterval(interval);
  }, [isAutoPlaying]);

  const handlePrev = () => { setIsAutoPlaying(false); setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length); };
  const handleNext = () => { setIsAutoPlaying(false); setCurrentIndex((prev) => (prev + 1) % testimonials.length); };

  const getVisibleTestimonials = () => {
    const visible = [];
    for (let i = 0; i < 3; i++) {
      visible.push(testimonials[(currentIndex + i) % testimonials.length]);
    }
    return visible;
  };

  return (
    <section className="py-20 bg-[#313536]">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-white mb-4">Testimonials From Satisfied Clients</h2>
          <p className="text-lg text-gray-300">Thousands of companies depend on us to secure and defend their trademarks.</p>
        </div>

        <div className="max-w-7xl mx-auto relative">
          {/* Desktop View - 3 Cards */}
          <div className="hidden md:grid md:grid-cols-3 gap-6">
            {getVisibleTestimonials().map((t) => (
              <Card key={t.id} className="p-6 shadow-lg flex flex-col h-full bg-[#313536] border-gray-600">
                <div className="flex items-center mb-4">
                  {[...Array(t.rating)].map((_, i) => (
                    <Star key={i} className="h-5 w-5 text-[#e8a8c8] fill-current" />
                  ))}
                </div>
                <p className="text-white mb-6 leading-relaxed flex-grow">"{t.content}"</p>
                <div>
                  <p className="font-semibold text-white">{t.name}</p>
                  <p className="text-gray-300 text-sm">{t.role}</p>
                </div>
              </Card>
            ))}
          </div>

          {/* Mobile Slider */}
          <div className="md:hidden overflow-x-auto">
            <div className="flex gap-4 pb-4" style={{ scrollSnapType: 'x mandatory' }}>
              {testimonials.map((t) => (
                <Card key={t.id} className="flex-shrink-0 w-full p-6 shadow-lg bg-[#313536] border-gray-600" style={{ scrollSnapAlign: 'start' }}>
                  <div className="flex items-center mb-4">
                    {[...Array(t.rating)].map((_, i) => (
                      <Star key={i} className="h-5 w-5 text-[#e8a8c8] fill-current" />
                    ))}
                  </div>
                  <p className="text-white mb-6 leading-relaxed">"{t.content}"</p>
                  <div>
                    <p className="font-semibold text-white">{t.name}</p>
                    <p className="text-gray-300 text-sm">{t.role}</p>
                  </div>
                </Card>
              ))}
            </div>
          </div>

          {/* Navigation Arrows */}
          <div className="hidden md:flex items-center justify-center gap-4 mt-8">
            <Button variant="outline" size="icon" onClick={handlePrev} className="rounded-full bg-secondary">
              <ChevronLeft className="h-5 w-5 text-primary" />
            </Button>
            <div className="flex gap-2">
              {testimonials.map((_, index) => (
                <button key={index} onClick={() => { setIsAutoPlaying(false); setCurrentIndex(index); }}
                  className={`h-2 rounded-full transition-all ${index === currentIndex ? 'w-8 bg-[#ba2a84]' : 'w-2 bg-gray-300'}`}
                />
              ))}
            </div>
            <Button variant="outline" size="icon" onClick={handleNext} className="rounded-full bg-secondary">
              <ChevronRight className="h-5 w-5 text-primary" />
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};
